import SignupProgressBannerContainer from "./SignupProgressContainer";

export default SignupProgressBannerContainer;
